export var CONFIG_CONSTANT = {
  GENERAL_CONFIGS: '',
  ONBOARDING_CONFIGS: '',
  ACCOUNTS_CONFIGS: '',
  LISTINGS_CONFIGS: '',
  ALL_INTEGRATIONS: '',
  PAYMENT_CONFIGS: '',
  SEO_CONFIGS: '',
  ADDRESS_CONFIGS: '',
  ORDERS_CONFIGS: '',
  SHIPPING_CONFIGS: '',
  SUPERADMIN: '',
  DEFAULT_EXTENSION: [
    {
      id: 1,
      href: 'https://marketing.tradly.app/dashboard',
      icon: 'https://media.tradly.app/images/marketplace/52892/ma(1)-TcjqA2Fw.webp',
      title: 'Marketing',
      isShow: true,
      key_name: 'workflow',
      sub_menus: [],
      iframe_url: 'https://marketing.tradly.app/dashboard',
      is_linkable: true,
      iframe_height: '100%',
      is_dynamic_side_menu: true,
      iframe_sidebar_max_width: '1000px',
      is_open_via_iframe_sidepan: true,
    },
  ],
};

// fn
export const set_root_configs = ({all_configs}) => {
  CONFIG_CONSTANT.GENERAL_CONFIGS = all_configs?.general ?? {};
  CONFIG_CONSTANT.ONBOARDING_CONFIGS = all_configs?.onboarding ?? {};
  CONFIG_CONSTANT.ACCOUNTS_CONFIGS = all_configs?.accounts ?? {};
  CONFIG_CONSTANT.LISTINGS_CONFIGS = all_configs?.listings ?? {};
  CONFIG_CONSTANT.ALL_INTEGRATIONS = all_configs?.integrations ?? {};
  CONFIG_CONSTANT.PAYMENT_CONFIGS = all_configs?.payments ?? {};
  CONFIG_CONSTANT.SEO_CONFIGS = all_configs?.seo ?? {};
  CONFIG_CONSTANT.SOCIAL_CONFIGS = all_configs?.social ?? {};
  CONFIG_CONSTANT.ADDRESS_CONFIGS = all_configs?.address ?? {};
  CONFIG_CONSTANT.ORDERS_CONFIGS = all_configs?.orders ?? {};
  CONFIG_CONSTANT.SHIPPING_CONFIGS = all_configs?.shipping ?? {};
};
